/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators
*/



const validateName = (value) => {
  const regex = /^[a-zA-ZáéíóúüñäëïöüÿàèìòùÀÈÌÒÙÁÉÍÓÚÝÄËÏÖÜ\s-]+$/;

  if (value == null) return 'Must enter a valid name.';
  if (regex.test(value)) {
    return true;
  }

  return 'Must enter a valid name.';
};



export default validateName;
